var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
var Pagination = function (_a) {
    var pageCourante = _a.pageCourante, totalPages = _a.totalPages, changePage = _a.changePage;
    var isCurrentPage = function (numeroPage) {
        return pageCourante === numeroPage;
    };
    var premierePageAttributs = useMemo(function () {
        if (isCurrentPage(1)) {
            return {};
        }
        else {
            return {
                href: '#',
                onClick: function () { return changePage(1); }
            };
        }
    }, [pageCourante]);
    var pagePrecedenteAttributs = useMemo(function () {
        if (isCurrentPage(Math.max(1, pageCourante - 1))) {
            return {};
        }
        else {
            return {
                href: '#',
                onClick: function () { return changePage(pageCourante - 1); }
            };
        }
    }, [pageCourante]);
    var pageSuivanteAttributs = useMemo(function () {
        if (isCurrentPage(totalPages)) {
            return {};
        }
        else {
            return {
                href: '#',
                onClick: function () { return changePage(pageCourante + 1); }
            };
        }
    }, [pageCourante, totalPages]);
    var dernierePageAttributs = useMemo(function () {
        if (!isCurrentPage(totalPages)) {
            return {
                href: "#",
                onClick: function () { return changePage(totalPages); },
            };
        }
        return {};
    }, [pageCourante, totalPages]);
    var displayPage = function (numeroPage, displayLG) {
        if (displayLG === void 0) { displayLG = ""; }
        return (React.createElement("li", null,
            React.createElement("a", { className: "fr-pagination__link ".concat(displayLG), "aria-current": isCurrentPage(numeroPage) ? "page" : undefined, href: isCurrentPage(numeroPage) ? undefined : "#", title: "Page ".concat(numeroPage), onClick: function () { return changePage(numeroPage); } }, numeroPage)));
    };
    var displayFirstsPages = useMemo(function () {
        return (React.createElement(React.Fragment, null, totalPages > 0 && displayPage(1, "fr-displayed-lg")));
    }, [totalPages, pageCourante]);
    var displayPagesAutourCourante = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            pageCourante - 2 > 1 && pageCourante - 2 < totalPages - 1 && totalPages > 5 && (React.createElement("li", null,
                React.createElement("a", { className: "fr-pagination__link fr-displayed-lg" }, "\u2026"))),
            pageCourante === totalPages &&
                totalPages >= 5 &&
                displayPage(pageCourante - 3),
            ((pageCourante === totalPages && totalPages >= 4) || (pageCourante === totalPages - 1 && totalPages >= 5)) &&
                displayPage(pageCourante - 2),
            pageCourante - 1 > 1 &&
                displayPage(pageCourante - 1),
            pageCourante !== 1 && pageCourante !== totalPages &&
                displayPage(pageCourante),
            pageCourante + 1 < totalPages &&
                displayPage(pageCourante + 1),
            ((pageCourante === 1 && totalPages >= 4) || (pageCourante === 2 && totalPages >= 5)) &&
                displayPage(pageCourante + 2),
            pageCourante === 1 && totalPages >= 5 &&
                displayPage(pageCourante + 3),
            pageCourante + 2 < totalPages && totalPages > 5 && (React.createElement("li", null,
                React.createElement("a", { className: "fr-pagination__link fr-displayed-lg" }, "\u2026")))));
    }, [pageCourante, totalPages]);
    var displayLastPages = useMemo(function () {
        return (React.createElement(React.Fragment, null, totalPages >= 2 && displayPage(totalPages, "fr-displayed-lg")));
    }, [totalPages, pageCourante]);
    return (React.createElement("nav", { role: "navigation", className: "fr-pagination", "aria-label": "Pagination" },
        React.createElement("ul", { className: "fr-pagination__list" },
            React.createElement("li", null,
                React.createElement("a", __assign({ className: "fr-pagination__link fr-pagination__link--first" }, premierePageAttributs), "Premi\u00E8re page")),
            React.createElement("li", null,
                React.createElement("a", __assign({ className: "fr-pagination__link fr-pagination__link--prev fr-pagination__link--lg-label" }, pagePrecedenteAttributs), "Page Pr\u00E9c\u00E9dente")),
            displayFirstsPages,
            displayPagesAutourCourante,
            displayLastPages,
            React.createElement("li", null,
                React.createElement("a", __assign({ className: "fr-pagination__link fr-pagination__link--next fr-pagination__link--lg-label" }, pageSuivanteAttributs), "Page suivante")),
            React.createElement("li", null,
                React.createElement("a", __assign({ className: "fr-pagination__link fr-pagination__link--last" }, dernierePageAttributs), "Derni\u00E8re page")))));
};
export default Pagination;
